import React, { useEffect, useState } from 'react';
import { getCustomerSubscriptionDetails } from "../../../../api/endpoints/customer";
import { showDeleteAlert } from "../../../../utils/swalAlerts/showDeleteAlert";
import showSuccessAlert from '../../../../utils/swalAlerts/showSuccessAlert';
import showErrorAlert from '../../../../utils/swalAlerts/showErrorAlert';
import { updateCustomerSubscription }  from '../../../../api/endpoints/customer';

const CustomerSubscriptionFormModal = ({ show, onClose, compId, customerId }) => {
  const [validated, setValidated] = useState(false);
  const [ error, setError ] = useState({});
  const [ currentData, setCurrentData ] = useState({});
  const [form, setForm] = useState({
    c_credit : 0,
    c_validity : 0,
    c_max_devices : 0,
  })

  useEffect(() => {
      const fetchData = async () => {
        if(show){
          const response = await getCustomerSubscriptionDetails(compId, customerId);
          if(response.status === 200){
            const accData = response.data.data;
            setForm({
              c_credit : 0,
              c_validity : 0,
              c_max_devices : accData.max_devices,
            });
            setCurrentData(accData);
          }          
        }
      };
      fetchData();
     },[customerId, show]);

  const handleMaxChange = (e) => {
    const { name, value } = e.target;
    if (/^[1-5]?$/.test(value)) {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleValidationChange = (e) => {
    const val = e.target.value;
    const name = e.target.name;
    const numericVal = Number(val);
    
    if(val === ""){
      setForm((prev) => ({ ...prev, [name]: val }));
      return true;
    }
    
    if (/^\d+$/.test(val) && numericVal >= 0 ) {
      if (numericVal + Number(currentData.validity) > 720) {
        //setError(prev => ({ ...prev, [name]: `Total (used + input) cannot exceed 720. Used: ${form.c_validity}` }));
        return false;
      }
    } else {
      //setError(prev => ({ ...prev, [name]: `Enter a number between 1 and 720` }));
      return false;
    }
    setForm((prev) => ({ ...prev, [name]: val }));
  };

  const handleCreditChange = (e) => {
    const val = e.target.value;
    const name = e.target.name;
    
    if (val === '') {
      setForm((prev) => ({ ...prev, [name]: '' }));
      return;
    }

    if (/^\d+$/.test(val) && Number(val) <= 999999) {
      setForm((prev) => ({ ...prev, [name]: val }));
    }
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;

    if (formElement.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    // add confirmation dialog box
    console.log(form);
    //onSave(form);
    showDeleteAlert({
      title: 'Are you sure you want to update subsription ?',
      message: '',
      confirmButtonText: 'Yes!',
      isInfo: true,
      onConfirm: async () => {
        try {
          const response = await updateCustomerSubscription(compId, customerId, form);
          if(response.status === 200){
            // send sucess 
            if(response.data.success){
              showSuccessAlert({
                title: "Subscription for customer",
                message: response.data.message,
                icon: "success",
                cancelText : 'Ok',
              })
              onClose();
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} id="customerAccountModal" tabindex="-1" aria-labelledby="customerAccountModalLabel" aria-modal="true">
        <div className="modal-dialog model-fullscreen-md-down">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="customerAccountModalgridLabel">Customer Account</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
                </div>
                <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="fs-16 fw-semibold">{currentData.credit}</h5>
                                <p className="text-muted">Credit Left</p>
                            </div>
                            <div className="progress animated-progress rounded-bottom rounded-0" style={{height: "6px"}}>
                                <div className="progress-bar bg-success rounded-0" role="progressbar" style={{ width: "30%"}} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar bg-info rounded-0" role="progressbar" style={{ width: "50%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar rounded-0" role="progressbar" style={{ width: "20%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="fs-16 fw-semibold">{currentData.validity} Days</h5>
                                <p className="text-muted">Validity Left</p>
                            </div>
                            <div className="progress animated-progress rounded-bottom rounded-0" style={{height: "6px"}}>
                                <div className="progress-bar bg-success rounded-0" role="progressbar" style={{ width: "30%"}} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar bg-info rounded-0" role="progressbar" style={{ width: "50%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar rounded-0" role="progressbar" style={{ width: "20%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="fs-16 fw-semibold">{currentData.active_devices}/{currentData.max_devices}</h5>
                                <p className="text-muted">Devices</p>
                            </div>
                            <div className="progress animated-progress rounded-bottom rounded-0" style={{height: "6px"}}>
                                <div className="progress-bar bg-success rounded-0" role="progressbar" style={{ width: "30%"}} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar bg-info rounded-0" role="progressbar" style={{ width: "50%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                <div className="progress-bar rounded-0" role="progressbar" style={{ width: "20%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                      </div>
                    </div>
                    <form onSubmit={handleSubmit} >
                      <div className="row g-3">
                        <div className="col-xxl-12">
                          <div>
                            <label for="txt" className="form-label"> Credit</label>
                            <input 
                              type="text" 
                              className="form-control" 
                              name="c_credit" 
                              value={form.c_credit} 
                              onChange={handleCreditChange} 
                              inputMode="numeric" 
                              placeholder="1-9" 
                              maxLength={7}/>
                              <p className="text-muted">(This credit will be added to the above shown credit.)</p>
                          </div>
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-xxl-12">
                          <div>
                            <label for="txt" className="form-label"> Validity</label>
                            <input 
                              type="text" 
                              className="form-control" 
                              name="c_validity" 
                              value={form.c_validity} 
                              onChange={handleValidationChange} 
                              inputMode="numeric" 
                              placeholder="1-720" 
                              required/>
                              <p className="text-muted">(These validity days will be added to the above shown validaity.)</p>
                              {error.c_validity && <div className="invalid-feedback">{error.c_validity}</div>}
                          </div>
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-xxl-12">
                          <div>
                            <label for="txt" className="form-label"> Max Dvices</label>
                            <input 
                              type="text" 
                              className="form-control" 
                              name="c_max_devices" 
                              value={form.c_max_devices} 
                              onChange={handleMaxChange} 
                              inputMode="numeric" 
                              pattern="[1-5]{1}" 
                              placeholder="1-5" 
                              maxLength={1} 
                              required/>
                              <p className="text-muted">(This number represents the total devices allowed — it will not be added on top of the existing limit.)</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="hstack gap-2 justify-content-end">
                          <button type="button" className="btn btn-light" data-bs-dismiss="modal"  onClick={onClose}>Close</button>
                          <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                      </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CustomerSubscriptionFormModal